import Phone from '../../assets/iPhoneX.png';
import './hero.css';

function Hero() {
  return (
    <section className="hero" id="hero">
      <div>
        <p>
          Simple and Efficient
          Payment Solutions
        </p>
        <button><a href="http://apps.paythru.ng/Accounts/onboarding" target="_blank" rel="noreferrer">Get Started</a></button>
      </div>
      <img src={Phone} alt="" />
    </section>
  );
}

export default Hero;
